// eslint-disable-next-line no-unused-vars
import React from 'react';

const highlightText = (text, queries) => {
  if (!queries?.length) return text;

  const escapedQueries = queries.map(q => q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const parts = text.split(new RegExp(`(${escapedQueries.join('|')})`, 'gi'));

  return (
    <span>
      {parts.map((part, i) => queries.some(q => part.toLowerCase() === q.toLowerCase()) ? (
        // eslint-disable-next-line react/no-array-index-key
        <mark key={ i } className="highlightText">{ part }</mark>
      ) : part
      )}
    </span>
  );
};

export default highlightText;
